import { useNextRouter } from '@/data/Content/_NextRouter';
import { useLocalization } from '@/data/Localization';
import { useCurrentRoute } from 'integration/hooks/useCurrentRoute';
import { usePreviousRouteContext } from 'integration/hooks/usePreviousRoute';
import valueIsString from 'integration/utils/typeAssertions/valueIsString';
import { useCallback, useMemo } from 'react';

interface UseReplaceAuthRouteArgs {
	shouldCallToModal: boolean;
}

const EXCLUDE_PATHS = ['error-de-sesion'];

export const useReplaceAuthRoute = ({ shouldCallToModal }: UseReplaceAuthRouteArgs) => {
	const router = useNextRouter();
	const RouteLocal = useLocalization('Routes');
	const currentRoute = useCurrentRoute();
	const prevRoute = usePreviousRouteContext();

	const prevClean = useMemo(() => {
		try {
			if (valueIsString(prevRoute)) {
				const prevRouteExcluded = EXCLUDE_PATHS.find((path) => prevRoute.includes(path));
				return prevRouteExcluded ? null : prevRoute;
			}
			return null;
		} catch {
			return null;
		}
	}, [prevRoute]);

	const onReplaceAuthRoute = useCallback(async () => {
		if (shouldCallToModal) {
			await router.push(currentRoute);
		} else if (prevClean) {
			await router.push(prevClean);
		} else if (router.query.flow === 'checkout') {
			await router.push(RouteLocal.CheckOut.route.t());
		} else {
			await router.push(RouteLocal.Account.route.t());
		}
	}, [router, currentRoute, shouldCallToModal, RouteLocal, prevClean]);

	return {
		onReplaceAuthRoute,
	};
};
